import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login.vue'
import ResetPassword from '../components/ResetPassword.vue'
import Forbidden from '../components/common/Forbidden.vue'
import Dashboard from '../components/Dashboard.vue'
import UserList from '../components/user/UserList.vue'
import UserEditor from '../components/user/UserEditor.vue'
import HotelList from '../components/hotel/HotelList.vue'
import HotelEditor from '../components/hotel/HotelEditor.vue'
import VehicleList from '../components/vehicle/VehicleList.vue'
import VehicleEditor from '../components/vehicle/VehicleEditor.vue'
import GuestList from '../components/guest/GuestList.vue'
import GuestEditor from '../components/guest/GuestEditor.vue'
import AppAdminUserList from '../components/appadminuser/AppAdminUserList.vue'
import AppAdminUserEditor from '../components/appadminuser/AppAdminUserEditor.vue'
import Profile from '../components/profile/Profile.vue'
import store from '../store'
import {USER_REQUEST} from "../store/actions/user";
import ability from '../util/abilities';
import * as routes from './routes';


Vue.use(Router);

const canNavigate = (to) => {
    return to.matched.some(route => {
        return ability.can('manage', route.name)
    }) || to.path === routes.FORBIDDEN.route;
};

export default {
    router: new Router({
        routes: [
            {
                path: routes.LOGIN.route,
                name: routes.LOGIN.name,
                component: Login,
                meta: {
                    layout: "anon",
                    excludeAuth: true,
                }
            },
            {
                path: routes.RESET_PASSWORD.route,
                component: ResetPassword,
                meta: {
                    layout: "anon",
                    excludeAuth: true,
                },
                props: (route) => {
                    const token = route.query.token;
                    return {token}
                },
            },
            {
                path: routes.FORBIDDEN.route,
                component: Forbidden,
            },
            {
                name: routes.INDEX.name,
                path: routes.INDEX.route,
                component: Dashboard,

            },
            {
                name: routes.DASHBOARD.name,
                path: routes.DASHBOARD.route,
                component: Dashboard,
            },
            {
                name: routes.USER_LIST.name,
                path: routes.USER_LIST.route,
                component: UserList,
            },
            {
                name: routes.USER_NEW.name,
                path: routes.USER_NEW.route,
                component: UserEditor,
            },
            {
                name: routes.USER_EDIT.name,
                path: routes.USER_EDIT.route,
                component: UserEditor,
                props: (route) => {
                    const userId = Number.parseInt(route.params.userId, 10)
                    return {userId}
                },
            },
            {
                name: routes.APP_ADMIN_USER_LIST.name,
                path: routes.APP_ADMIN_USER_LIST.route,
                component: AppAdminUserList,
            },
            {
                name: routes.APP_ADMIN_USER_NEW.name,
                path: routes.APP_ADMIN_USER_NEW.route,
                component: AppAdminUserEditor,
            },
            {
                name: routes.APP_ADMIN_USER_EDIT.name,
                path: routes.APP_ADMIN_USER_EDIT.route,
                component: AppAdminUserEditor,
                props: (route) => {
                    const userId = Number.parseInt(route.params.userId, 10)
                    return {userId}
                },
            },
            {
                name: routes.HOTEL_LIST.name,
                path: routes.HOTEL_LIST.route,
                component: HotelList,
            },
            {
                name: routes.HOTEL_NEW.name,
                path: routes.HOTEL_NEW.route,
                component: HotelEditor,
            },
            {
                name: routes.HOTEL_EDIT.name,
                path: routes.HOTEL_EDIT.route,
                component: HotelEditor,
                props: (route) => {
                    const hotelId = Number.parseInt(route.params.hotelId, 10)
                    return {hotelId}
                },
            },
            {
                name: routes.VEHICLE_LIST.name,
                path: routes.VEHICLE_LIST.route,
                component: VehicleList,
            },
            {
                name: routes.VEHICLE_NEW.name,
                path: routes.VEHICLE_NEW.route,
                component: VehicleEditor,
            },
            {
                name: routes.VEHICLE_EDIT.name,
                path: routes.VEHICLE_EDIT.route,
                component: VehicleEditor,
                props: (route) => {
                    const vehicleId = Number.parseInt(route.params.vehicleId, 10)
                    return {vehicleId}
                },
            },
            {
                name: routes.GUEST_LIST.name,
                path: routes.GUEST_LIST.route,
                component: GuestList,
            },
            {
                name: routes.GUEST_NEW.name,
                path: routes.GUEST_NEW.route,
                component: GuestEditor,
            },
            {
                name: routes.GUEST_EDIT.name,
                path: routes.GUEST_EDIT.route,
                component: GuestEditor,
                props: (route) => {
                    const guestId = Number.parseInt(route.params.guestId, 10)
                    return {guestId}
                },
            },
            {
                name: routes.PROFILE.name,
                path: routes.PROFILE.route,
                component: Profile,
            },
            {
                path: '*',
                component: Login,
            },
        ]
    }),
    init() {
        this.router.beforeEach((to, from, next) => {
            if (to.meta.excludeAuth) {
                if (!store.getters.isAuthenticated || to.path === routes.RESET_PASSWORD.route)
                    next();
                else
                    next(routes.DASHBOARD.route)

            } else {
                if (store.getters.isAuthenticated) {
                    if (!store.getters.isUserLoaded) {
                        store.dispatch(USER_REQUEST).then(() => {
                            if (canNavigate(to))
                                next();
                            else
                                return next(routes.FORBIDDEN.route)
                        });
                    } else {
                        if (canNavigate(to))
                            next();
                        else
                            next(routes.FORBIDDEN.route)
                    }
                } else {
                    next(routes.LOGIN.route)
                }
            }
        });
        this.router.afterEach((to) => {
            const body = $('body');
            $('.custom-modal-backdrop').removeClass('in');
            if (to.path === routes.LOGIN.route || to.path === routes.RESET_PASSWORD.route || !store.getters.isAuthenticated && !store.getters.isUserLoaded()) {
                if (!body.hasClass('blank')) {
                    body.addClass('blank');
                }
            } else {
                if (body.hasClass('blank')) {
                    body.removeClass('blank');
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/router/index.js